extend = require 'extend'

class Preferences
	constructor: (@storage) ->

	get: (preferenceName = null) =>
		jsonString = @storage.getItem 'preferences'

		base =
			numberOfCycles: 2
			studentMinutes: 15
			teacherMinutes: 5
		prefs = {}

		try
			prefs = JSON.parse(jsonString) ? base
		catch

		if preferenceName
			return prefs[preferenceName]
		else
			return prefs

	set: (values) ->
		prefs = extend(true, {}, @get(), values)
		@storage.setItem('preferences', JSON.stringify(prefs))

	setPreference: (preferenceName, value) ->
		prefs = @get()
		prefs[preferenceName] = value
		@storage.setItem('preferences', JSON.stringify(prefs))

module.exports = Preferences



// WEBPACK FOOTER //
// ./frontend/olos/js/lib/preferences.coffee